/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateDeviceJoinTokenRequestBody = {
  /**
   * The agent the enrolled device inherits its policy from.
   */
  agentId: string;
  /**
   * How long the token stays redeemable. Defaults to one hour.
   */
  expiresInSeconds?: number | undefined;
};

/** @internal */
export type CreateDeviceJoinTokenRequestBody$Outbound = {
  agent_id: string;
  expires_in_seconds: number;
};

/** @internal */
export const CreateDeviceJoinTokenRequestBody$outboundSchema: z.ZodMiniType<
  CreateDeviceJoinTokenRequestBody$Outbound,
  CreateDeviceJoinTokenRequestBody
> = z.pipe(
  z.object({
    agentId: z.string(),
    expiresInSeconds: z._default(z.int(), 3600),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      expiresInSeconds: "expires_in_seconds",
    });
  }),
);

export function createDeviceJoinTokenRequestBodyToJSON(
  createDeviceJoinTokenRequestBody: CreateDeviceJoinTokenRequestBody,
): string {
  return JSON.stringify(
    CreateDeviceJoinTokenRequestBody$outboundSchema.parse(
      createDeviceJoinTokenRequestBody,
    ),
  );
}
